import { seenAddressOf, type DeclaredUnit } from '@uniticket/shared';

// L'écriture d'une adresse dans le tableau des logements — partagée par les logements du bâtiment et par ceux de
// la même adresse postale rangés ailleurs (N41), pour qu'une même adresse se lise partout de la même façon.

type Parts = { streetName: string | null; houseNumber: string | null; houseNumberExtension: string | null };

/** L'adresse du DMP sur une ligne : rue, numéro, et l'extension quand elle dit autre chose que le numéro. */
export function mduAddress(a: Parts): string {
  const ext = a.houseNumberExtension && a.houseNumberExtension !== a.houseNumber ? a.houseNumberExtension : null;
  return [a.streetName, a.houseNumber, ext].filter(Boolean).join(' ') || '—';
}

// N37 / D0309-6 (décisions des 11-09 et 07-10) — l'adresse que l'OPÉRATEUR a déclarée pour ce logement, telle que
// le tableau l'écrit à droite de la flèche ; `null` quand sa déclaration ne s'écarte pas du DMP (rue, numéro,
// extension — la boîte a sa propre colonne). `full` va dans l'infobulle. Dans la cellule, la rue n'est répétée
// que si c'est elle qui change : « Rue Neuve 27 → 27 27A » se lit mieux que deux adresses entières côte à côte.
export function declaredAddress(a: DeclaredUnit): { full: string; short: string } | null {
  if (a.mappedStreetName == null && a.mappedHouseNumber == null && a.mappedHouseNumberExtension == null) return null;
  const seen = seenAddressOf(a);
  const number = [seen.houseNumber, seen.houseNumberExtension].filter(Boolean).join(' ');
  const full = [seen.streetName, number].filter(Boolean).join(' ') || '—';
  return { full, short: a.mappedStreetName != null ? full : (number || '—') };
}
